export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-random/src/defaultSource.js
// module id = m3Qw
// module chunks = 0